import React from "react";
import logo from "../assets/imgs/zing_white_logo.png";

const APIDocsPage = () => {
    return (<div className="main-wrapper">
        <div className="">
            <div className="row no-gutters">
                <div className="col-md-3">
                    <div className="sider">
                        <a className="navbar-brand" href="/">
                            <img src={logo} className="img-fluid logo"/>
                        </a>

                        <ul className="list-unstyled sider-text">
                            <li><h2 className="header-text">
                                Your packages delivered securely
                            </h2></li>
                            <li>
                                <p>
                                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor
                                    incididunt ut labore et dolore magna aliqua.
                                </p>
                            </li>
                        </ul>
                    </div>
                </div>
                <div className="col-md-9">
                    <div className="main">
                        <div className="center-block align-middle">
                            <div className="container">

                            </div>
                        </div>
                        <div className="bottom-block">
                            <div className="container">
                                {/*<div className="row justify-content-center">*/}
                                {/*    <div className="col-md-3 text-left">*/}
                                {/*        <button className="btn btn-secondary btn-md"*/}
                                {/*                onClick={() => setPreviousState({*/}
                                {/*                    currentState: change.componentType,*/}
                                {/*                    isActive: true,*/}
                                {/*                    phone: change.phone,*/}
                                {/*                    refId: change.refId*/}
                                {/*                })}>*/}
                                {/*            Previous*/}
                                {/*        </button>*/}
                                {/*    </div>*/}
                                {/*    <div className="col-md-6 text-center">*/}
                                {/*        <p>Having troubles? <span>Get Help</span></p>*/}
                                {/*    </div>*/}
                                {/*    <div className="col-md-3 text-right">*/}
                                {/*        <button className="btn btn-primary btn-md"*/}
                                {/*                onClick={() => setButtonClick(true)}>*/}
                                {/*            Next*/}
                                {/*        </button>*/}
                                {/*    </div>*/}
                                {/*</div>*/}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        {/*<Header/>*/}
    </div>);
};

export default APIDocsPage;

